export const getwebinars = (programaid)=>{
    let sql = `
    query{
        webinarsByPrograma(programa_id:${programaid}){
          id
          nombre
          programa_id
          carga_horaria
          ciudad_emision
          sede_emision
          fecha_webinar
          fecha_inicio_matriculacion
          fecha_fin_matriculacion
          fecha_registro
          estado
          registrados
        }
      }
    `
    return sql
}